/**
 * BLOCK - CAROUSEL MEDIA PRODUCT - LISTENERS
 */

setupEventListenersForProductMediaCarousel();

// Creates the event listeners
function setupEventListenersForProductMediaCarousel() {
  // On clicking on an image with lightbox zoom enabled
  document.querySelectorAll('.carousel--media-prod .carousel-cell[data-thumbnail="false"][data-zoom="lightbox"][data-type="image"]').forEach((element) => {
    element.addEventListener('click', clickImageWithLightboxZoomHandler);
  });
  
  // On clicking on an image with hover zoom enabled
  document.querySelectorAll('.carousel--media-prod .carousel-cell[data-thumbnail="false"][data-zoom="hover"][data-type="image"]').forEach((element) => {
    element.addEventListener('click', clickImageWithHoverZoomHandler);
  });
  
  // On clicking on a product media carousel thumbnail
  document.querySelectorAll('.carousel--media-prod .carousel-cell[data-thumbnail="true"]').forEach((element) => {
    element.addEventListener('click', clickProductMediaCarouselThumbnailHandler);
  });
}

/**
 * BLOCK - CAROUSEL MEDIA PRODUCT - GENERAL
 */

// On clicking on an image with lightbox zoom enabled
function clickImageWithLightboxZoomHandler() {    
  lightboxZoomProductMediaCarouselImage();
}

// On clicking on an image with hover zoom enabled
function clickImageWithHoverZoomHandler() {    
  window.innerWidth > 1024 ? hoverZoomProductMediaCarouselImage() : lightboxZoomProductMediaCarouselImage();
}

// On moving the mouse on an image with hover zoom enabled
function hoverImageWithHoverZoomHandler() {  
  if (window.innerWidth > 1024) changeZoomPosition();
}

// On leaving the image with hover zoom enabled
function leaveImageWithHoverZoomHandler() {  
  if (window.innerWidth > 1024) resetZoom();
}

// On clicking on a product media carousel thumbnail
function clickProductMediaCarouselThumbnailHandler() {    
  changeProductMediaCarouselImage();
}

// Zooms the images of a product media carousel by opening a lightbox
function lightboxZoomProductMediaCarouselImage() {
  var target = event.currentTarget,
      modal = document.querySelector('.modal--image-zoom'),
      modalId = modal.getAttribute('id'),
      imageHtml = target.querySelector('img').outerHTML;

  openModalWithId(modalId);
  modal.querySelector('.modal__body--inner').innerHTML = imageHtml;
}

// Zooms the images of a product media carousel by hovering
function hoverZoomProductMediaCarouselImage() {
  var target = event.currentTarget,
      overlay = target.querySelector('.image-zoom-overlay'),
      image = target.querySelector('img'),
      imageSrc = image.getAttribute('src');

  target.classList.toggle('zoomed');
  
  if (target.classList.contains('zoomed')) {
    target.addEventListener('mousemove', hoverImageWithHoverZoomHandler);
    target.addEventListener('mouseleave', leaveImageWithHoverZoomHandler);
  } else {
    target.removeEventListener('mousemove', hoverImageWithHoverZoomHandler);
    target.removeEventListener('mouseleave', leaveImageWithHoverZoomHandler);    
  }

  if (overlay !== null) {
    overlay.remove();
  } else {
    var overlayHtml = document.createElement('div');
    
    overlayHtml.setAttribute('class', 'image-zoom-overlay');
    overlayHtml.setAttribute('style', 'background-image: url(' + imageSrc + ');');
    image.parentNode.appendChild(overlayHtml);
  }
}

// Changes the part of the image that is being viewed during the zoom
function changeZoomPosition() {
  var target = event.currentTarget,
      overlay = target.querySelector('.image-zoom-overlay'),
      image = target.querySelector('img'),
      ratio = image.getBoundingClientRect().height / image.getBoundingClientRect().width,
      container = target.getBoundingClientRect(),
      xPosition = event.clientX - container.left,
      yPosition = event.clientY - container.top,
      xPercent = xPosition / (image.getBoundingClientRect().width / 100),
      yPercent = yPosition / ((image.getBoundingClientRect().width * ratio) / 100),
      newPosition = xPercent + '% ' + yPercent + '%';

  overlay.style.backgroundPosition = newPosition;
}

// Cancels the zoom of the image
function resetZoom() {
  event.target.click();
}

// Changes the current image of a product media carousel
function changeProductMediaCarouselImage() {
  var target = event.currentTarget,
      section = target.closest('.section__page'),
      mediaId = target.dataset.mediaId,
      productSlideshow = section.querySelector('.carousel--media-prod:has(.carousel-cell[data-thumbnail="false"])'),
      productSlideshowImages = productSlideshow.querySelectorAll('.carousel-cell'),
      productSlideshowImagesArray = [...productSlideshowImages],
      mediaToFind = productSlideshowImagesArray.filter((image) => image.dataset.mediaId == mediaId);

  if (mediaToFind[0] && isSliderInitialized(productSlideshow)) {
    getSiblings(target).forEach((element) => {
      element.classList.remove('swiper-slide-active');
    });
    
    target.classList.add('swiper-slide-active');
    productSlideshow.closest('.carousel').swiper.slideTo(parseInt(mediaToFind[0].getAttribute('data-slide-index')), parseInt(productSlideshow.dataset.speed), false);
  }
}